import React, { useCallback } from 'react';
import { styled } from '@mui/material/styles';
import { TextField, Typography } from '@mui/material';
import { NODE_UI, stopPropagation } from './nodeUiStyles';

/**
 * NodeTimePicker — Time picker using native HTML time input.
 * Used by: Time Delay, Schedule Start.
 */

const Label = styled(Typography)(({ theme }) => ({
  fontSize: NODE_UI.fontSize.label,
  fontWeight: NODE_UI.fontWeight.label,
  color: theme.palette.text.secondary,
  lineHeight: 1.4,
  marginBottom: '4px',
  userSelect: 'none',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    fontSize: NODE_UI.fontSize.value,
    borderRadius: NODE_UI.borderRadiusSm,
    backgroundColor: theme.palette.background.default,
    '& fieldset': { borderColor: theme.palette.divider },
    '&:hover fieldset': { borderColor: theme.palette.text.secondary },
    '&.Mui-focused fieldset': { borderColor: theme.palette.text.primary, borderWidth: '1px' },
  },
  '& .MuiInputBase-input': {
    padding: NODE_UI.input.padding,
    fontSize: NODE_UI.fontSize.value,
  },
}));

const NodeTimePicker = React.memo(function NodeTimePicker({
  label,
  value = '',
  onChange,
  disabled = false,
  fullWidth = true,
  sx,
}) {
  const handleChange = useCallback((e) => {
    onChange?.(e.target.value);
  }, [onChange]);

  return (
    <div onMouseDown={stopPropagation} onClick={stopPropagation} onPointerDown={stopPropagation}>
      {label && <Label>{label}</Label>}
      <StyledTextField
        type="time"
        size="small"
        variant="outlined"
        fullWidth={fullWidth}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        InputLabelProps={{ shrink: true }}
        sx={sx}
      />
    </div>
  );
});

export default NodeTimePicker;
